import { render, staticRenderFns } from "./lkuPinjamanPrepaid.vue?vue&type=template&id=5d131b2f&"
import script from "./lkuPinjamanPrepaid.vue?vue&type=script&lang=js&"
export * from "./lkuPinjamanPrepaid.vue?vue&type=script&lang=js&"
import style0 from "./lkuPinjamanPrepaid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports